module.exports = __webpack_public_path__ + "img/mukeBanner.732c554f.png";